<template>
	<div class="page-in">
	<van-nav-bar
	  :title="$t('安全中心')"
	  fixed
	  placeholder
	  left-arrow
	  z-index="99"
	  @click-left="back"
	  :border="false"
	  v-if="isMobileFlag"
	/>
	<div class="inside-page" v-if="userData">
		<!-- m -->
		<div class="m-container" v-if="isMobileFlag">
			<div class="security-cells">
				<div class="security-row">
					<div class="security-row_label">{{$t('登录密码')}}</div>
					<div class="security-row_value">
						<el-link type="info" @click="showLoginPwd">
							{{$t('修改')}}
						</el-link>
					</div>
					<span class="el-icon-arrow-right"></span>
				</div>
				<div class="security-row">
					<div class="security-row_label">{{$t('支付密码')}}</div>
					<div class="security-row_value">
						<el-link :type="userData.paypwd == ''? 'danger' : 'info'" @click="showPayPwd">
							{{userData.paypwd == "" ? $t('未设置') : $t('修改') }}
						</el-link>
					</div>
					<span class="el-icon-arrow-right"></span>
				</div>
				<div class="security-row" v-if="false">
					<div class="security-row_label">绑定手机</div>
					<div class="security-row_value">
						
						<el-link
						      :type="userData.mobile == ''  || !this.userData.mobile? 'danger' : (userData.is_mobile ? 'success' : 'danger')" 
						      @click="showPhone"
						    >
						      {{ userData.mobile == '' || !this.userData.mobile ? $t('未设置') : (userData.is_mobile ? $t('已验证') : $t('未验证')) }}
						</el-link>
					</div>
					<span class="el-icon-arrow-right"></span>
				</div>
				<div class="security-row" v-if="false">
					<div class="security-row_label">绑定邮箱</div>
					<div class="security-row_value">
						<el-link 
						      :type="userData.email == ''  || !this.userData.email ? 'danger' : (userData.is_email ? 'success' : 'danger')" 
						      @click="showEmail"
						    >
						      {{ userData.email == '' || !this.userData.email ? $t('未设置') : (userData.is_email ? $t('已验证') : $t('未验证')) }}
						</el-link>
					</div>
					<span class="el-icon-arrow-right"></span>
				</div>
			</div>
		</div>
		<!-- pc -->
		<div class="layui-container" v-else>
			<div class="ucenter">
				<div class="uc-breadcrumb" >
					<el-link type="info" @click="back">
						<span class="iconfont icon-l-left"></span><span>{{$t('返回')}}</span>
					</el-link>	
				</div>
				<UserPanel></UserPanel>
				<div class="ucenter-ht"></div>
				<div class="ucenter-content">
					<div class="ucenter-cell">
						<div class="ucenter-content-hd"><span class="tt">{{$t('安全中心')}}</span></div>
						<div class="security-cells">
							<div class="security-row">
								<div class="security-row_label">{{$t('登录密码')}}</div>
								<div class="security-row_value">
									<el-link type="info" @click="showLoginPwd">
										{{$t('修改')}}
									</el-link>
								</div>
								<span class="el-icon-arrow-right"></span>
							</div>
							<div class="security-row">
								<div class="security-row_label">{{$t('支付密码')}}</div>
								<div class="security-row_value">
									<el-link :type="$store.state.userInfo.paypwd == ''? 'danger' : 'info'" @click="showPayPwd">
										{{$store.state.userInfo.paypwd == "" ? $t('未设置') : $t('修改') }}
									</el-link>
								</div>
								<span class="el-icon-arrow-right"></span>
							</div>
							<div class="security-row" v-if="false">
								<div class="security-row_label">{{$t('绑定手机')}}</div>
								<div class="security-row_value">
									<el-link :underline="false" @click="showPhone">{{$t('已验证')}}</el-link>
								</div>
							</div>
							<div class="security-row" v-if="false">
								<div class="security-row_label">{{$t('绑定邮箱')}}</div>
								<div class="security-row_value">
									<el-link type="danger" @click="showEmail">{{$t('未验证')}}</el-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<emailDialog ref="emailDialog"></emailDialog>
	<loginPwdDialog ref="loginPwdDialog"></loginPwdDialog>
	<payPwdDialog ref="payPwdDialog" @reload="handleReload"></payPwdDialog>
	<phoneDialog ref="phoneDialog"></phoneDialog>
	</div>
</template>
<script>
	import UserPanel from './components/UserPanel'
	import emailDialog from './components/emailDialog'
	import loginPwdDialog from './components/loginDialog'
	import payPwdDialog from './components/payDialog'
	import phoneDialog from './components/phoneDialog'
	
	export default {
		components:{
			UserPanel,
			emailDialog,
			loginPwdDialog,
			payPwdDialog,
			phoneDialog
		},
		data() {
			return {
				userData:null
			};
		},
		methods:{
			showLoginPwd(){
				this.$refs.loginPwdDialog.show = true
			},
			showPayPwd(){
				this.$refs.payPwdDialog.show = true
			},
			showPhone(){
				this.$refs.phoneDialog.show = true
			},
			showEmail(){
				this.$refs.emailDialog.show = true
			},
			handleReload(){
				this.updateUserInfo()
				location.reload()
			}
		},
		mounted() {
			if(this.$helper.get('userInfo')){
				this.userData = this.$helper.get('userInfo');
			}
			
		}
	}
</script>
<style scoped>
	.uc-breadcrumb{
		margin-bottom: 15px;
	}
	.ucenter-ht{
		height: 20px;
	}
	.security-row{
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		font-size: 16px;
	}
	.security-row_label{
		min-width: 110px;
		margin-right: 30px;
	}
	.security-row .el-link{
		font-size: 16px;
	}
	
	@media (max-width:992px) {
		.security-row{
			padding: 15px 0;
			margin-bottom: 0;
			border-bottom: 1px solid #cfcfcf;
		}
		.security-row_value{
			text-align: right;
			flex: 1;
		}
	}
	
	
	
	
</style>
